import clsx from 'clsx';
import { PiCheckCircle, PiWarning } from 'react-icons/pi';
import { Notification } from '@_/ui';
import { useNotificationStore } from './notificationStore.ts';

export function Notifications({
  bounds,
  className
}: {
  bounds?: Partial<Pick<DOMRect, 'top' | 'bottom' | 'left' | 'right'>>;
  className?: string;
}) {
  const { notifications, removeNotification } = useNotificationStore();

  return (
    <div
      className={clsx(
        'pointer-events-none fixed inset-0 z-50 mx-auto flex items-end px-4 py-6 sm:items-start sm:p-6',
        className
      )}
      style={{
        top: bounds?.top ? `${bounds.top}px` : undefined,
        bottom: bounds?.bottom ? `${bounds.bottom}px` : undefined,
        left: bounds?.left ? `${bounds.left}px` : undefined,
        right: bounds?.right ? `${bounds.right}px` : undefined
      }}
    >
      <div className="flex w-full flex-col items-center gap-y-4 sm:items-end">
        {notifications.map(notification => (
          <Notification
            key={notification.id}
            heading={notification.heading}
            icon={
              notification.icon || (
                <>
                  {notification.type === 'error' && <PiWarning className="text-rose-400" />}
                  {notification.type === 'success' && (
                    <PiCheckCircle className="text-emerald-400" />
                  )}
                </>
              )
            }
            open={notification.isOpen}
            message={notification.message}
            onClose={() => removeNotification(notification.id)}
          />
        ))}
      </div>
    </div>
  );
}
